export default __webpack_public_path__ + "static/media/offing-lynne-thompson.89037480.webp";